module.exports = __webpack_public_path__ + "img/search2.172a4892.gif";